import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Logo from '../components/Logo';
import OrderForm from '../components/OrderForm';
import { content } from '../data/content';
import { findPack } from '../data/product';

/**
 * صفحة الطلب مستقلة ومركّزة: هيدر مبسّط بلا روابط تنقّل، لأن كل رابط هنا
 * مخرج محتمل قبل إتمام الطلب. الرابط الوحيد للخروج هو الرجوع للصفحة الرئيسية.
 */
export default function OrderPage() {
  const [searchParams] = useSearchParams();
  const [pack, setPack] = useState(() => findPack(searchParams.get('pack')));

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
        <div className="container mx-auto max-w-7xl py-3 flex items-center justify-between gap-4">
          <Link to="/">
            <Logo className="text-2xl md:text-3xl" />
          </Link>

          <Link
            to="/"
            className="text-z-navy hover:text-z-red transition font-bold text-xs md:text-sm flex items-center gap-2"
          >
            {content.orderBack} <i className="fa-solid fa-arrow-left text-xs" />
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <OrderForm pack={pack} setPack={setPack} />
      </main>

      <footer className="border-t border-gray-200 py-6">
        <div className="container mx-auto max-w-7xl text-center text-xs text-z-gray">
          &copy; {new Date().getFullYear()} <span className="font-serif text-z-navy">zalyas</span>. {content.copyright}
        </div>
      </footer>
    </div>
  );
}
